module.exports = __webpack_public_path__ + "static/media/PartMaker.ac85b715.png";